var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,_vm._g({tag:"component",staticClass:"ui-btn",class:_vm.classes,attrs:{"to":_vm.to,"type":_vm.to ? null : _vm.type}},_vm.listeners),[(_vm.icon)?_c('v-icon',{attrs:{"size":_vm.size === 'sm' ? 14 : 16,"color":"currentColor"}},[_vm._v(_vm._s(_vm.icon))]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }